<template>
	<div>
		<multi-table
			v-loading="loading"
			class="muti-table"
			ref="multiTable"
			:distanceTop="0"
			:columns="columns"
			:list="tableData"
			:total="total"
			:page="pageInfo"
			:pageFixed="true"
			:showPager="false"
		>
			<empty slot="empty"></empty>
		</multi-table>

		<yx-pagination
			:total="total"
			:current-page="pageInfo.page_index"
			:page-size="pageInfo.page_size"
			@size-change="sizeChange"
			@current-change="currentChange"
		/>
	</div>
</template>

<script>
import { columns } from './columns';
import { activityRecordList } from '@/api/secondColonelManage';
export default {
	data() {
		return {
			loading: false,
			tableData: [],
			total: 0,
			columns,
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
		};
	},
	props: {
		params: {
			type: Object,
			default: () => ({}),
		},
	},
	methods: {
		getList() {
			this.loading = true;
			activityRecordList({
				...this.pageInfo,
				...this.params,
			})
				.then(res => {
					let list = res.list.map(val => ({
						...val,
						...val.applyActivityInfo,
						...val.applyProductInfo,
					}));
					this.tableData = list.map(item => ({
						...item,
						// 将合并后的内容赋值给 applyStatusDesc
						applyStatusDesc: `${item.applyStatusDesc}${item.failReason ? ':'+item.failReason : ''}` 
					}));
					this.total = res.page.item_total;
				})
				.catch(() => {
					this.tableData = [];
					this.total = 0;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		sizeChange(value) {
			this.pageInfo.page_size = value;
			this.getList();
		},
		currentChange(value) {
			this.pageInfo.page_index = value;
			this.getList();
		},
	},
};
</script>

<style></style>
